module.exports = __webpack_public_path__ + "img/better-than-taxi.cfd5f180.jpg";